import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { Dialog } from 'district-ui-client/components/dialog'
import ModalDefaultHeader from 'district-ui-client/components/modal-default/header'
import ModalDefaultBody from 'district-ui-client/components/modal-default/body'
import { ModalDefaultFooter } from 'district-ui-client/components/modal-default/footer'

interface Signature {
  Element: HTMLDivElement
  Args: {
    onClose: () => unknown
  }
  Blocks: {
    default: [
      {
        header: any
        body: any
        footer: any
      },
    ]
  }
}

export const ModalDefault: TOC<Signature> = <template>
  <Dialog class="min-w-[32rem] max-w-[48rem] overflow-hidden rounded-2xl" @onClose={{@onClose}} @showBackdrop={{true}}>
    <div
      class="relative rounded-md border border-solid border-dusty-black-200 bg-clip-padding outline-0"
      data-test-modal-content
      ...attributes
    >
      {{yield
        (hash
          header=(component ModalDefaultHeader onClose=@onClose)
          body=(component ModalDefaultBody)
          footer=(component ModalDefaultFooter)
        )
      }}
    </div>
  </Dialog>
</template>

export default ModalDefault
